import "./studentlist.css"
import Student from "../../components/student/Student"
const StudentList = () => {
    return (
        <div className="studentList">
            <div className="studentListContainer">
                <Student />
            </div>
        </div>
    )
}

export default StudentList
